<div class="reports-container">
  <div class="reports-topbar">
    <div class="topbar-left">
      <h1>
        Checked-Out Items
        <small>Items currently out on rental</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        <a routerLink="/reports">Reports</a> /
        <span class="current">Checked-Out Items</span>
      </div>
    </div>
    <div class="topbar-right">
      <app-report-date-range />
      <a routerLink="/reports" class="btn btn-outline btn-sm">
        <i class="bi bi-arrow-left"></i> Back to Reports
      </a>
      <button class="btn btn-primary" (click)="exportData()"><i class="bi bi-download"></i> Export</button>
    </div>
  </div>

  <div class="report-period">
    <i class="bi bi-calendar3"></i>
    <span>Showing data for {{ dateRange.appliedLabel() }}</span>
  </div>

  <div class="report-card">
    <div class="report-header">
      <div class="report-title">
        <i class="bi bi-clipboard-check" style="color:#10b981;"></i>
        <h2>Checked-Out Items</h2>
        <span class="report-badge success">{{ checkouts().length }} items</span>
      </div>
    </div>
    <div class="report-body">
      <div class="checked-out-list">
        @for (checkout of checkouts(); track checkout.id) {
          <div class="checked-item">
            <span class="asset-name">{{ checkout.equipment }}</span>
            <span class="asset-funeral">{{ checkout.checkoutNumber }}</span>
            <span class="asset-due" [class.overdue]="isOverdue(checkout.dueDate, checkout.status)">
              Due: {{ formatDate(checkout.dueDate) }}
            </span>
          </div>
        } @empty {
          <p class="report-empty">No checkouts found for {{ dateRange.appliedLabel() }}.</p>
        }
      </div>
      <div class="report-footer">
        <span>{{ checkouts().length }} checked out for {{ dateRange.appliedLabel() }}</span>
      </div>
    </div>
  </div>
</div>
